import { Controller } from "@hotwired/stimulus"

// 목록 일괄 선택 — 체크박스 선택 개수에 따라 제출 버튼 활성/비활성, 전체 선택 토글.
// 대기 제품 탭의 [선택 삭제]에서 사용. 제출 시 확인 다이얼로그.
//
// targets:
//   all    — 헤더 전체 선택 체크박스
//   item   — 행별 항목 체크박스 (name="codes[]")
//   count  — 선택 개수 표시 span
//   submit — 제출 버튼 (data-confirm-message 로 확인 문구)
export default class extends Controller {
  static targets = ["all", "item", "count", "submit"]

  connect() {
    this.refresh()
  }

  // 전체 선택 체크박스 → 모든 항목 동기화
  toggleAll() {
    const checked = this.allTarget.checked
    this.itemTargets.forEach((cb) => { cb.checked = checked })
    this.refresh()
  }

  // 선택 상태 변경 시 개수·버튼·전체체크 갱신
  refresh() {
    const selected = this.itemTargets.filter((cb) => cb.checked).length

    if (this.hasCountTarget) this.countTarget.textContent = selected
    if (this.hasSubmitTarget) this.submitTarget.disabled = selected === 0

    // 전체 선택 체크박스 상태 (일부만 선택 시 indeterminate)
    if (this.hasAllTarget) {
      const total = this.itemTargets.length
      this.allTarget.checked = selected > 0 && selected === total
      this.allTarget.indeterminate = selected > 0 && selected < total
    }
  }

  // 제출 전 확인 (form submit 에 바인딩)
  confirmSubmit(event) {
    const message = this.hasSubmitTarget && this.submitTarget.dataset.confirmMessage
    if (message && !window.confirm(message)) {
      event.preventDefault()
    }
  }
}
